import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Calendar, Users, FileText, Clock, LogOut } from 'lucide-react';

const Navbar = ({ userRole, setUser }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path: string) => location.pathname === path ? "bg-blue-600 text-white shadow-md" : "text-slate-500 hover:bg-slate-100";

  return (
    <header className="bg-white border-b sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <div className="bg-blue-600 p-2 rounded-lg text-white"><Clock size={20} /></div>
          <span className="font-black text-slate-800 hidden sm:inline">Smart Attendance</span>
        </div>

        <nav className="flex bg-slate-100 p-1 rounded-xl overflow-x-auto">
          {userRole === 'admin' ? (
            <>
              <Link to="/" className={`px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap ${isActive('/')}`}>Daily</Link>
              <Link to="/staff" className={`px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap ${isActive('/staff')}`}>Staff</Link>
              <Link to="/report" className={`px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap ${isActive('/report')}`}>Reports</Link>
            </>
          ) : (
            <span className="px-4 py-2 text-xs font-bold text-blue-600">Staff Portal</span>
          )}
        </nav>

        <button onClick={() => { setUser(null); navigate('/login'); }} className="text-red-500 p-2 hover:bg-red-50 rounded-lg">
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};
export default Navbar;